export default "__VITE_ASSET__BNQ5R3Ih__"